import React, { useState } from "react";
import Layout from "../layout/Layout";
import { useCopyToClipboard } from "usehooks-ts";
import SyntaxHighlighter from "react-syntax-highlighter";
import atelierCaveDark from "react-syntax-highlighter/dist/esm/styles/hljs/atelier-cave-dark";
import { Link } from "react-router-dom";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import DoneIcon from "@mui/icons-material/Done";

const PaiementRedirige = () => {
  const [copy] = useCopyToClipboard();
  const [isCopiedCode3, setIsCopiedCode3] = useState(false);
  const [isCopiedResponse2, setIsCopiedResponse2] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("curl");

  const handleLanguageChange = (e) => {
    setSelectedLanguage(e.target.value);
  };

  const data2 = [
    {
      key: "codeOperateur",
      label: "codeOperateur",
      description:
        "Code d'opérateur lié au service, dans ce cas 'WAVE_SKAN' pour Wave ou 'CARTE_BANCAIRE_CINETPAY_SKAN' pour carte bancaire",
      value: "WAVE_SKAN",
    },
    {
      key: "référence",
      label: "reference",
      description:
        "Numéro unique fourni par l'opérateur, associé à l'opération en cours",
      value: "YYYYYYYYY",
    },
    {
      key: "numero",
      label: "numero",
      description: "Numéro de téléphone à débiter",
      value: "XXXXXXXXXX",
    },
    {
      key: "montant",
      label: "montant",
      description: "Montant associé à la transaction ou à l'opération (100FR minimum pour les paiements par carte bancaire)",
      value: "MONTANT",
    },
    {
      key: "typeOperateur",
      label: "typeOperateur",
      description: "La valeur doit rester REDIRIGE",
      value: "REDIRIGE",
    },
    {
      key: "nom",
      label: "nom",
      description: "Le nom du client effectuant le paiement (facultatif)",
      value: "NOM",
    },
    {
      key: "email",
      label: "email",
      description:
        "L'adresse e-mail du client (facultatif)",
      value: "xxx@gmail.com",
    },
    {
      key: "numeroClient",
      label: "numeroClient",
      description:
        "Le numéro du client effectuant le paiement (facultatif)",
      value: "XXXXXXXX",
    },
    {
      key: "urlRetour",
      label: "urlRetour",
      description:
        "Le client est redirigé vers cette URL après validation du paiement. Cette URL doit être HTTPS",
      value: "XXXX",
    },
  ];

  const codeSnippets3 = {
    curl: `curl --location \\
  --request POST "https://paiement.skanci.com/mobilepayment/payer" \\
  --header "X-Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9..." \\
  --header "Content-Type: application/x-www-form-urlencoded" \\
  --data-urlencode "codeOperateur=WAVE_SKAN" \\
  --data-urlencode "reference=0199ce75-9a65-7768-9ec0-941272d5ed10" \\
  --data-urlencode "montant=5" \\
  --data-urlencode "typeOperateur=REDIRIGE" \\
  --data-urlencode "nom=TANFOLO JOEL" \\
  --data-urlencode "email=joel.tanfolo@skanci.com" \\
  --data-urlencode "numeroClient=0500000000" \\
  --data-urlencode "numero=0700000000" \\
  --data-urlencode "urlRetour=https://skanci.com"`,
  };

  return (
    <Layout>
      <div className="relative w-full ">
        <div className="absolute z-50 top-4 right-10  ">
          <select
            value={selectedLanguage}
            onChange={handleLanguageChange}
            className="select select-bordered text-white bg-black w-full max-w-xs"
          >
            <option selected value="curl">
              cURL
            </option>
          </select>
        </div>
        <div className="content z-30 relative pt-[2rem]   h-[100vh]  overflow-y-auto pb-[5rem] md:pb-0 lg:pb-0">
          <div className=" flex flex-col gap-4 mt-6 md:mt-0 lg:mt-[2rem] pb-6 pl-[0.5rem] md:pl-[2rem] lg:pl-[2rem] md:mr-[50%] lg:mr-[50%] mr-0 clear-right   ">
            <h2
              id="paiementDirect"
              className=" border-l-[3px] border-yellow-500  pl-8 text-[25px] font-[700]   "
            >
              Paiement avec réponse Redirigé
            </h2>
            <hr className=" border-t-[2px] border-dashed border-gray-200 h-[2px] " />
            <div className="flex flex-col gap-4">
              <div className="flex flex-row">
                <p className="text-[18px] text-[#48494a] ">
                  Dans le cas d'un paiement avec reponse redirigé, après la
                  requete de paiement, SkanPayment attend la validation du
                  paiement par le client, le{" "}
                  <span className=" font-bold">code</span> est a la valeur 20 et
                  le <span className=" font-bold"> message </span> contient l'url de validation du payement. Toute valeur
                  du <span className=" font-bold">code</span> différente de 20
                  signifie un echec du paiement. La cause de l'échec est
                  spécifiée dans le{" "}
                  <span className=" font-bold"> message </span>
                  de la reponse.
                </p>
              </div>

              <div className="bg-[#eff7f2] px-2 py-2 ">
                <p className=" flex flex-row gap-3 ">
                  <span className="bg-[#5eb583] flex items-center text-white py-1 px-2 rounded-lg">
                    POST
                  </span>{" "}
                  <span className="md:block lg:block hidden">
                    https://paiement.skanci.com/mobilepayment/payer
                  </span>
                  <span className="md:hidden lg:hidden flex">
                    https://paiement.skanci.com /mobilepayment/payer
                  </span>
                </p>
              </div>
              <div className="overflow-x-auto">
                <table className="table">
                  <thead>
                    <tr>
                      <th>HEADERS</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b-[0]">
                      <td className="font-bold">Content-Type</td>
                      <td>application/x-www-form-urlencoded</td>
                    </tr>
                    <tr className="border-b-[0]">
                      <td className="font-bold">X-Authorization</td>
                      <td>Bearer {"<token>"}</td>
                    </tr>
                  </tbody>
                </table>

                <table className="table">
                  <thead>
                    <tr>
                      <th>BODY</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data2.map((item) => (
                      <tr key={item.key} className="border-b-[0]">
                        <td className="font-bold ">{item.label}</td>
                        <td>{item.value}</td>
                        <td>{item.description}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-6">
            <div className=" relative my-2 md:mt-[-32rem] lg:mt-[-70rem] mt-0 md:float-right lg:float-right float-none clear-left md:w-[41%] lg:w-[41%] w-[90%] mx-auto bg-[#101011] md:mr-[1rem] lg:mr-[1rem] mr-[1rem] text-[#eee] overflow-x-auto lg:overflow-hidden rounded-lg">
              <div className="flex flex-row px-2 justify-between bg-[#1d1d1e] border-b-[2px]">
                <span>{selectedLanguage}</span>
                <button
                  onClick={() => {
                    setIsCopiedCode3(true);
                    copy(codeSnippets3[selectedLanguage]);
                    setTimeout(() => {
                      setIsCopiedCode3(false);
                    }, 2000);
                  }}
                >
                  {" "}
                  {isCopiedCode3 ? (
                    <DoneIcon fontSize="small" />
                  ) : (
                    <ContentPasteIcon fontSize="small" />
                  )}
                </button>
              </div>
              <SyntaxHighlighter
                language={selectedLanguage}
                style={atelierCaveDark}
                wrapLongLines={true}
              >
                {codeSnippets3[selectedLanguage]}
              </SyntaxHighlighter>
            </div>
            <div className=" relative  md:float-right lg:float-right float-none clear-right md:w-[41%] lg:w-[41%] w-[90%] mx-auto bg-[#101011] md:mr-[1rem]  lg:mr-[1rem] mr-[1rem] text-[#eee] overflow-x-auto lg:overflow-hidden rounded-lg">
              <div className="flex flex-row px-2 justify-between bg-[#1d1d1e] border-b-[2px]">
                <span>
                  reponse:{" "}
                  <span className="bg-green-600 px-2 rounded-lg text-[10px]">
                    200 OK
                  </span>
                </span>
                <button
                  onClick={() => {
                    navigator.clipboard.writeText(`
                    {
                      "code": 20,
                      "message": "https://pay.wave.com/c/{...}"
                    }`);
                    setIsCopiedResponse2(true);
                    setTimeout(() => {
                      setIsCopiedResponse2(false);
                    }, 3000);
                  }}
                >
                  {" "}
                  {isCopiedResponse2 ? (
                    <DoneIcon fontSize="small" />
                  ) : (
                    <ContentPasteIcon fontSize="small" />
                  )}
                </button>
              </div>
              <SyntaxHighlighter
                language="ruby"
                style={atelierCaveDark}
                showLineNumbers={true}
                wrapLongLines={true}
              >
                {`{
"code": 20,
"message": "https://pay.wave.com/c/{...}"
}`}
              </SyntaxHighlighter>
            </div>
          </div>
        </div>
        <div className="boxDark md:absolute lg:absolute w-[45%] bg-[#282a36] h-full top-0 right-0 bottom-0"></div>
      </div>
    </Layout>
  );
};

export default PaiementRedirige;
